"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wallet = exports.Path = void 0;
var lodash_1 = require("lodash");
var TxSkeleton_1 = require("../../Consensus/TxSkeleton");
var js_sha3_1 = require("js-sha3");
var Serialization_1 = require("../../Handlers/Serialization");
var __1 = require("../..");
var Mnemonic_1 = __importDefault(require("../../Handlers/Mnemonic"));
var ContractWitness_1 = require("../../Consensus/Types/Witness/ContractWitness");
var Witness_1 = require("../../Consensus/Types/Witness/Witness");
var EmptyPKWitness_1 = require("../../Consensus/Types/RawWitness/EmptyPKWitness");
var RawWitnesses_1 = require("../../Consensus/Transaction/RawWitnesses");
var BigInteger = require("bigi");
var Path = /** @class */ (function () {
    function Path(change, index) {
        this.path = change + "/" + index;
    }
    Path.getPath = function (change, index) {
        return new Path(change, index);
    };
    Path.getExternal = function (index) {
        if (index === void 0) { index = 0; }
        return Path.getPath(0, index).getPath();
    };
    Path.getChange = function (index) {
        if (index === void 0) { index = 0; }
        return Path.getPath(1, index).getPath();
    };
    Path.prototype.getPath = function () {
        return this.path;
    };
    Path.prototype.getFullZenPath = function (account) {
        return "m/44'/258'/" + account + "'/" + this.path;
    };
    return Path;
}());
exports.Path = Path;
var Wallet = /** @class */ (function () {
    function Wallet(extendedKey, actions, chain, index) {
        if (index === void 0) { index = 0; }
        this.extendedKey = extendedKey;
        this.actions = actions;
        this.chain = chain;
        if (extendedKey.hasPrivateKey())
            throw new Error("a wallet address does not expect a private key");
        this.externalPK = extendedKey.derivePath(Path.getExternal(index)).getPublicKey();
        this.changePK = extendedKey.derivePath(Path.getChange(index)).getPublicKey();
        this.unspentOutputs = [];
        this.syncToBlock = 0;
    }
    Wallet.fromMnemonic = function (key, actions, chain) {
        var zenKey;
        if (Mnemonic_1.default.validateMnemonic(key)) {
            zenKey = __1.ExtendedKey.fromMnemonic(key, "pub");
        }
        else {
            throw new Error('mnemonic seed is not valid');
        }
        return new Wallet(zenKey, actions, chain);
    };
    Wallet.bigi = function (number) {
        return new BigInteger(number.toString(10), 10, undefined);
    };
    Wallet.getExternalPath = function (account) {
        if (account === void 0) { account = 0; }
        return new Path(0, 0).getFullZenPath(account);
    };
    Wallet.getChangePath = function (account) {
        if (account === void 0) { account = 0; }
        return new Path(1, 0).getFullZenPath(account);
    };
    Wallet.prototype.getExternalPublicKey = function () {
        return this.externalPK;
    };
    Wallet.prototype.getExternalPublicKeyHash = function () {
        return this.externalPK.hash();
    };
    Wallet.prototype.getExternalAddress = function (chain) {
        if (chain === void 0) { chain = this.chain; }
        return this.externalPK.toAddress(chain);
    };
    Wallet.prototype.connectWallet = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([this.sync(), this.refresh()])];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Wallet.prototype.getActiveContracts = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actions.activeContracts()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Wallet.prototype.getBalance = function (addresses) {
        if (addresses === void 0) { addresses = this.getAddresses(this.chain); }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, lodash_1.reduce(this.getSpendableOutput(addresses), function (balance, pointedOutput) {
                                var _a = pointedOutput.spend, asset = _a.asset, a = _a.amount;
                                var amount = lodash_1.parseInt(a);
                                if (lodash_1.has(balance, asset)) {
                                    var accumulatedAmount = lodash_1.get(balance, asset);
                                    return lodash_1.set(balance, asset, accumulatedAmount + amount);
                                }
                                else {
                                    return lodash_1.set(balance, asset, amount);
                                }
                            }, {})];
                }
            });
        });
    };
    Wallet.prototype.submitRepoVote = function (repoVotingContract, commitID, phase, currentInterval, privates, publish) {
        if (publish === void 0) { publish = true; }
        return __awaiter(this, void 0, void 0, function () {
            var phaseSer, interSer, commitSer, message, sigs, messageBody, contractData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _a.sent();
                        phaseSer = __1.DataFactory.serialize(new __1.Str(phase));
                        interSer = __1.DataFactory.serialize(new __1.U32(BigInteger.valueOf(currentInterval)));
                        commitSer = __1.DataFactory.serialize(new __1.Str(commitID));
                        message = Buffer.from(js_sha3_1.sha3_256
                            .update(js_sha3_1.sha3_256(interSer))
                            .update(js_sha3_1.sha3_256(phaseSer))
                            .update(js_sha3_1.sha3_256(commitSer)).toString(), 'hex');
                        sigs = this.getVotingSignatures(message, privates);
                        messageBody = new __1.DataList([
                            new __1.Str(commitID),
                            new __1.Dictionary(sigs)
                        ]);
                        contractData = {
                            command: commitID,
                            messageBody: messageBody,
                            provideReturnAddress: false,
                        };
                        return [4 /*yield*/, this.executeContract({ address: repoVotingContract, contractData: contractData, privates: privates, publish: publish })];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Wallet.prototype.submitCGPBallot = function (cgpVotingContract, command, ballotData, isNomination, currentInterval, privates, publish) {
        if (publish === void 0) { publish = true; }
        return __awaiter(this, void 0, void 0, function () {
            var phase, ballot, interval, ballotSerialized, phaseSer, messageToCompute, message, sigs, messageBody, contractData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _a.sent();
                        phase = isNomination ? 'Nomination' : 'Vote';
                        ballot = new __1.Ballot(ballotData).toHex();
                        interval = __1.DataFactory.serialize(new __1.U32(BigInteger.valueOf(currentInterval)));
                        ballotSerialized = __1.DataFactory.serialize(new __1.Str(ballot));
                        phaseSer = __1.DataFactory.serialize(new __1.Str(phase));
                        messageToCompute = interval.toString().concat(phaseSer).concat(ballotSerialized);
                        message = __1.Hash.compute(messageToCompute).bytes;
                        sigs = this.getVotingSignatures(message, privates);
                        messageBody = new __1.Dictionary([
                            [command, new __1.Str(ballot)],
                            ['Signature', new __1.Dictionary(sigs)],
                        ]);
                        contractData = {
                            command: command,
                            messageBody: messageBody,
                            provideReturnAddress: false,
                        };
                        return [4 /*yield*/, this.executeContract({ address: cgpVotingContract, contractData: contractData, privates: privates, publish: publish })];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Wallet.prototype.signMessage = function (msg, path, privates) {
        switch (path) {
            case '0/0':
                return privates[0].sign(msg);
            case '1/0':
                return privates[1].sign(msg);
            default:
                throw new Error("Wrong Path");
        }
    };
    Wallet.prototype.getAddress = function (path) {
        return this.extendedKey.derivePath(path).toAddress(this.chain);
    };
    Wallet.prototype.getTransactions = function (skip, take) {
        if (skip === void 0) { skip = 0; }
        if (take === void 0) { take = 65536; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actions.getTransactions(this.getAddresses(), skip, take)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Wallet.prototype.getTransactionCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actions.getTransactionCount(this.getAddresses(this.chain))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Wallet.prototype.send = function (outputs, privates, publish) {
        if (publish === void 0) { publish = false; }
        return __awaiter(this, void 0, void 0, function () {
            var requiredAmounts, _a, inputs, change, txBuilder, changeAddress, tx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _b.sent();
                        requiredAmounts = this.getRequiredAmounts(outputs);
                        _a = this.collectInputs(requiredAmounts, privates), inputs = _a.inputs, change = _a.change;
                        txBuilder = this.addTxBuilderInputs(inputs);
                        outputs.forEach(function (output) { return txBuilder.addOutput(output.address, output.amount, output.asset); });
                        changeAddress = this.getChangeAddress();
                        lodash_1.forIn(change, function (amount, asset) { return txBuilder.addOutput(changeAddress, amount, asset); });
                        tx = txBuilder.sign();
                        if (!publish) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.actions.publish(tx)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/, tx.toHex()];
                }
            });
        });
    };
    Wallet.prototype.sendRaw = function (outputs) {
        return __awaiter(this, void 0, void 0, function () {
            var requiredAmounts, _a, inputs, change, txBuilder, rw;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _b.sent();
                        requiredAmounts = this.getRequiredAmounts(outputs);
                        _a = this.collectRaw(requiredAmounts), inputs = _a.inputs, change = _a.change;
                        txBuilder = new __1.TransactionBuilder(this.chain);
                        inputs.forEach(function (_a) {
                            var input = _a[0];
                            txBuilder.addInput(input.outpoint.txHash, input.outpoint.index);
                        });
                        outputs.forEach(function (output) { return txBuilder.addOutput(output.address, output.amount, output.asset); });
                        lodash_1.forIn(change, function (amount, asset) { return txBuilder.addOutput(_this.getChangeAddress(), amount, asset); });
                        rw = new RawWitnesses_1.RawWitnesses(inputs.map(function (_a) {
                            var keyPath = _a[1], publicKey = _a[2];
                            return new EmptyPKWitness_1.EmptyPkWitness(Witness_1.SigHash.TxHash, publicKey, keyPath);
                        }));
                        return [2 /*return*/, txBuilder.getUnsignedRawTransaction(rw)];
                }
            });
        });
    };
    Wallet.prototype.executeContract = function (_a) {
        var _b = _a === void 0 ? {} : _a, address = _b.address, contractData = _b.contractData, _c = _b.privates, privates = _c === void 0 ? undefined : _c, _d = _b.publish, publish = _d === void 0 ? false : _d;
        return __awaiter(this, void 0, void 0, function () {
            var changeLock, externalLock, requiredAmounts, txOutputs, tempFeeAmount, _e, inputs, change, txInputs, changeOutputs, txSkeleton, sender, unsignedTx;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        changeLock = new __1.PK(this.changePK.hash());
                        externalLock = new __1.PK(this.externalPK.hash());
                        txOutputs = [];
                        return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _f.sent();
                        return [4 /*yield*/, this.checkContractActivation(address)];
                    case 2:
                        _f.sent();
                        if (lodash_1.isEmpty(contractData.outputs) || lodash_1.isUndefined(contractData.outputs)) {
                            tempFeeAmount = '1';
                            requiredAmounts = { "00": tempFeeAmount };
                            txOutputs = [new __1.Output(new __1.Fee(), new __1.Spend(__1.Asset.Zen, tempFeeAmount))];
                        }
                        else {
                            requiredAmounts = this.getRequiredAmounts(contractData.outputs);
                        }
                        _e = this.collectInputs(requiredAmounts, privates), inputs = _e.inputs, change = _e.change;
                        if (inputs.kind === 'without') {
                            txInputs = inputs.data
                                .map(function (input) {
                                return new __1.Input({
                                    kind: 'pointedOutput',
                                    outpoint: {
                                        kind: 'outpoint',
                                        txHash: new __1.Hash(input.outpoint.txHash),
                                        index: input.outpoint.index
                                    },
                                    output: new __1.Output(externalLock, new __1.Spend(new __1.Asset(input.spend.asset), input.spend.amount))
                                });
                            })
                                .filter(function (x) { return !!x; });
                        }
                        else {
                            txInputs = inputs.data
                                .map(function (_a) {
                                var input = _a[1];
                                return new __1.Input({
                                    kind: 'pointedOutput',
                                    outpoint: {
                                        kind: 'outpoint',
                                        txHash: new __1.Hash(input.outpoint.txHash),
                                        index: input.outpoint.index
                                    },
                                    output: new __1.Output(externalLock, new __1.Spend(new __1.Asset(input.spend.asset), input.spend.amount))
                                });
                            })
                                .filter(function (x) { return !!x; });
                        }
                        changeOutputs = lodash_1.map(change, function (amount, asset) {
                            return new __1.Output(changeLock, new __1.Spend(new __1.Asset(asset), amount.toString()));
                        });
                        txSkeleton = new TxSkeleton_1.TxSkeleton(txInputs, __spreadArrays(txOutputs, changeOutputs));
                        contractData = this.updateContractData(contractData);
                        sender = '';
                        if (contractData.sign) {
                            switch (contractData.sign) {
                                case '0/0':
                                    sender = this.externalPK.serialize().toString('hex');
                                    break;
                                case '1/0':
                                    sender = this.changePK.serialize().toString('hex');
                                    break;
                            }
                        }
                        return [4 /*yield*/, this.actions.executeContract(address, contractData.command, __1.DataFactory.serialize(contractData.messageBody), txSkeleton, sender)];
                    case 3:
                        unsignedTx = _f.sent();
                        if (!(publish && privates && inputs.kind === 'withPrv')) return [3 /*break*/, 5];
                        if (contractData.sign)
                            unsignedTx = __1.Transaction.fromHex(this.signContractWitness(unsignedTx, privates, contractData.sign));
                        unsignedTx.sign(inputs.data.map(function (_a) {
                            var key = _a[0];
                            return key;
                        }), Witness_1.SigHash.FollowingWitnesses);
                        return [4 /*yield*/, this.actions.publish(unsignedTx)];
                    case 4:
                        _f.sent();
                        _f.label = 5;
                    case 5: return [2 /*return*/, unsignedTx.toHex()];
                }
            });
        });
    };
    Wallet.prototype.extendContract = function (_a) {
        var _b = _a === void 0 ? {} : _a, contractId = _b.contractId, numberOfBlocks = _b.numberOfBlocks, _c = _b.privates, privates = _c === void 0 ? undefined : _c, _d = _b.publish, publish = _d === void 0 ? false : _d;
        return __awaiter(this, void 0, void 0, function () {
            var contractExist, codeLength, extensionSacrifice, _e, inputs, change, txBuilder, changeAddress, tx;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _f.sent();
                        return [4 /*yield*/, this.checkContractActivation(contractId)];
                    case 2:
                        contractExist = _f.sent();
                        if (typeof contractId === 'string') {
                            contractId = __1.ContractId.fromString(contractId);
                        }
                        codeLength = contractExist.code.length;
                        extensionSacrifice = codeLength * (numberOfBlocks + 1);
                        _e = this.collectInputs({ "00": extensionSacrifice.toString(10) }, privates), inputs = _e.inputs, change = _e.change;
                        txBuilder = this.addTxBuilderInputs(inputs);
                        txBuilder.addOutput(new __1.ExtensionSacrifice(contractId), extensionSacrifice, __1.Asset.Zen);
                        changeAddress = this.getChangeAddress();
                        lodash_1.forIn(change, function (amount, asset) { return txBuilder.addOutput(changeAddress, amount, asset); });
                        if (!(publish && privates && inputs.kind === 'withPrv')) return [3 /*break*/, 4];
                        tx = txBuilder.sign();
                        return [4 /*yield*/, this.actions.publish(tx)];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4: return [2 /*return*/, txBuilder.getUnsignedTransaction().toHex()];
                }
            });
        });
    };
    Wallet.prototype.activateContract = function (_a) {
        var _b = _a === void 0 ? {} : _a, code = _b.code, limit = _b.limit, numberOfBlocks = _b.numberOfBlocks, _c = _b.privates, privates = _c === void 0 ? undefined : _c, _d = _b.publish, publish = _d === void 0 ? false : _d;
        return __awaiter(this, void 0, void 0, function () {
            var contract, hints, queries, rlimit, codeLength, activationFee, activationSacrifice, requiredAmounts, _e, inputs, change, txBuilder, changeAddress, contractV0, tx;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!limit)
                            limit = 2723280;
                        return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _f.sent();
                        if (lodash_1.isEmpty(this.unspentOutputs))
                            throw new Error('not enough token');
                        return [4 /*yield*/, this.actions.activationOfContract(code, limit)];
                    case 2:
                        contract = _f.sent();
                        hints = contract.hints, queries = contract.queries, rlimit = contract.rlimit;
                        codeLength = code.length;
                        activationFee = Wallet.bigi(queries).multiply(Wallet.bigi(rlimit / 100));
                        activationSacrifice = Wallet.bigi(codeLength).multiply(Wallet.bigi(numberOfBlocks));
                        requiredAmounts = { "00": activationFee.add(activationSacrifice).toString(10) };
                        _e = this.collectInputs(requiredAmounts, privates), inputs = _e.inputs, change = _e.change;
                        txBuilder = this.addTxBuilderInputs(inputs);
                        txBuilder.addOutput(new __1.ActivationSacrifice(), activationSacrifice, __1.Asset.Zen);
                        txBuilder.addOutput(new __1.Fee(), activationFee, __1.Asset.Zen);
                        changeAddress = this.getChangeAddress();
                        lodash_1.forIn(change, function (amount, asset) { return txBuilder.addOutput(changeAddress, amount, asset); });
                        contractV0 = new __1.V0({ code: code, hints: hints, queries: queries, rlimit: rlimit });
                        if (!(publish && privates && inputs.kind === 'withPrv')) return [3 /*break*/, 4];
                        tx = txBuilder.sign(0, contractV0);
                        return [4 /*yield*/, this.actions.publish(tx)];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4: return [2 /*return*/, txBuilder.getUnsignedTransaction(0, contractV0).toHex()];
                }
            });
        });
    };
    Wallet.prototype.signTransaction = function (unspentTx, privateKeys) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _a.sent();
                        if (typeof unspentTx === 'string')
                            unspentTx = __1.Transaction.fromHex(unspentTx);
                        return [2 /*return*/, this.signFinalTx({ tx: unspentTx, privates: privateKeys })];
                }
            });
        });
    };
    Wallet.prototype.signContractExecution = function (unspentTx, sign, privateKeys) {
        return __awaiter(this, void 0, void 0, function () {
            var unSignedTx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _a.sent();
                        if (typeof unspentTx === 'string')
                            unspentTx = __1.Transaction.fromHex(unspentTx);
                        unSignedTx = sign ? __1.Transaction.fromHex(this.signContractWitness(unspentTx, privateKeys, sign)) : unspentTx;
                        return [2 /*return*/, this.signFinalTx({ tx: unSignedTx, privates: privateKeys, mode: Witness_1.SigHash.FollowingWitnesses })];
                }
            });
        });
    };
    Wallet.prototype.destroy = function (_a) {
        var _b = _a === void 0 ? {} : _a, outputs = _b.outputs, _c = _b.privates, privates = _c === void 0 ? undefined : _c, _d = _b.publish, publish = _d === void 0 ? false : _d;
        return __awaiter(this, void 0, void 0, function () {
            var requiredAmounts, _e, inputs, change, txBuilder, changeAddress, tx;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _f.sent();
                        requiredAmounts = this.getRequiredAmounts(outputs);
                        _e = this.collectInputs(requiredAmounts, privates), inputs = _e.inputs, change = _e.change;
                        txBuilder = this.addTxBuilderInputs(inputs);
                        outputs.forEach(function (output) { return txBuilder.addOutputDestroy(output.amount, output.asset); });
                        changeAddress = this.getChangeAddress();
                        lodash_1.forIn(change, function (amount, asset) { return txBuilder.addOutput(changeAddress, amount, asset); });
                        if (!(publish && privates && inputs.kind === 'withPrv')) return [3 /*break*/, 3];
                        tx = txBuilder.sign();
                        return [4 /*yield*/, this.actions.publish(tx)];
                    case 2:
                        _f.sent();
                        _f.label = 3;
                    case 3: return [2 /*return*/, txBuilder.getUnsignedTransaction().toHex()];
                }
            });
        });
    };
    Wallet.prototype.destroyRaw = function (outputs) {
        return __awaiter(this, void 0, void 0, function () {
            var requiredAmounts, _a, inputs, change, txBuilder, rw;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.connectWallet()];
                    case 1:
                        _b.sent();
                        requiredAmounts = this.getRequiredAmounts(outputs);
                        _a = this.collectRaw(requiredAmounts), inputs = _a.inputs, change = _a.change;
                        txBuilder = new __1.TransactionBuilder(this.chain);
                        inputs.forEach(function (_a) {
                            var input = _a[0];
                            txBuilder.addInput(input.outpoint.txHash, input.outpoint.index);
                        });
                        outputs.forEach(function (output) { return txBuilder.addOutputDestroy(output.amount, output.asset); });
                        lodash_1.forIn(change, function (amount, asset) { return txBuilder.addOutput(_this.getChangeAddress(), amount, asset); });
                        rw = new RawWitnesses_1.RawWitnesses(inputs.map(function (_a) {
                            var keyPath = _a[1], publicKey = _a[2];
                            return new EmptyPKWitness_1.EmptyPkWitness(Witness_1.SigHash.TxHash, publicKey, keyPath);
                        }));
                        return [2 /*return*/, txBuilder.getUnsignedRawTransaction(rw)];
                }
            });
        });
    };
    Wallet.prototype.collectRaw = function (requiredAmounts, addresses) {
        var _this = this;
        if (addresses === void 0) { addresses = this.getAddresses(); }
        var inputs = [];
        var change = {};
        lodash_1.forIn(requiredAmounts, function (amount, asset) {
            var collectedAmount = 0;
            for (var _i = 0, _a = _this.getSpendableOutput(addresses); _i < _a.length; _i++) {
                var output = _a[_i];
                var _b = output.lock, PK_1 = _b.PK, Coinbase = _b.Coinbase;
                var hash = '';
                var spendableLock = PK_1 || Coinbase;
                if (spendableLock && output.spend.asset === asset) {
                    collectedAmount += lodash_1.parseInt(output.spend.amount);
                    var keyPath = void 0;
                    var publicKey = void 0;
                    if (PK_1)
                        hash = PK_1.hash;
                    else if (Coinbase)
                        hash = Coinbase.pkHash;
                    if (hash === '')
                        throw new Error('hash is not spendable');
                    if (hash == _this.externalPK.hash().bytes.toString('hex')) {
                        keyPath = Wallet.getExternalPath();
                        publicKey = _this.getExternalPublicKey().serialize();
                    }
                    else {
                        keyPath = Wallet.getChangePath();
                        publicKey = _this.getChangePublicKey().serialize();
                    }
                    if (PK_1)
                        inputs.push([
                            {
                                outpoint: output.outpoint,
                                lock: {
                                    PK: {
                                        hash: hash,
                                        address: spendableLock.address
                                    }
                                },
                                spend: output.spend
                            },
                            keyPath,
                            publicKey
                        ]);
                    if (Coinbase)
                        inputs.push([
                            {
                                outpoint: output.outpoint,
                                lock: {
                                    Coinbase: {
                                        pkHash: hash,
                                        address: spendableLock.address,
                                        blockNumber: Coinbase.blockNumber
                                    }
                                },
                                spend: output.spend
                            },
                            keyPath,
                            publicKey
                        ]);
                    if (collectedAmount === lodash_1.parseInt(amount)) {
                        break;
                    }
                    else if (collectedAmount > lodash_1.parseInt(amount)) {
                        lodash_1.set(change, asset, collectedAmount - lodash_1.parseInt(amount));
                        break;
                    }
                }
            }
            if (collectedAmount < lodash_1.parseInt(amount)) {
                throw new Error('not enough tokens');
            }
        });
        return { inputs: inputs, change: change };
    };
    Wallet.prototype.getAddresses = function (chain) {
        if (chain === void 0) { chain = this.chain; }
        return [this.getExternalAddress(chain), this.getChangeAddress(chain)];
    };
    Wallet.prototype.getChangeAddress = function (chain) {
        if (chain === void 0) { chain = this.chain; }
        return this.changePK.toAddress(chain);
    };
    Wallet.prototype.signContractWitness = function (unsignedTx, privates, sign) {
        if (typeof unsignedTx === 'string')
            unsignedTx = __1.Transaction.fromHex(unsignedTx);
        var sender = '';
        var signPKey;
        var privatesIndex;
        switch (sign) {
            case '0/0':
                signPKey = this.externalPK;
                sender = signPKey.serialize().toString('hex');
                privatesIndex = 0;
                break;
            case '1/0':
                signPKey = this.changePK;
                sender = signPKey.serialize().toString('hex');
                privatesIndex = 1;
                break;
            default:
                throw new Error("multi wallet not yet activated");
        }
        if (signPKey && lodash_1.isNumber(privatesIndex)) {
            var witness = lodash_1.head(unsignedTx.witnesses.witnesses.filter(function (w) { return w instanceof ContractWitness_1.ContractWitness; }));
            var size = 32 + witness.contractId.getSize() + Serialization_1.getSizeOfString(witness.command) + 1 +
                (lodash_1.isUndefined(witness.messageBody) ? 0 : witness.messageBody.getSize());
            var message = Buffer.alloc(size);
            var txHash = unsignedTx.hash();
            txHash.bytes.copy(message);
            var offset = witness.contractId.write(message, 32);
            offset = Serialization_1.writeString(witness.command, message, offset);
            message.writeInt8(lodash_1.isUndefined(witness.messageBody) ? 0 : 1, offset);
            offset++;
            if (!lodash_1.isUndefined(witness.messageBody)) {
                witness.messageBody.write(message, offset);
            }
            var messageHash = Buffer.from(js_sha3_1.sha3_256(message), 'hex');
            var signature = privates[privatesIndex].sign(messageHash).serialize();
            var publicKey = signPKey.serialize();
            witness.signature = [publicKey, signature];
        }
        return unsignedTx.toHex();
    };
    Wallet.prototype.signFinalTx = function (_a) {
        var tx = _a.tx, privates = _a.privates, mode = _a.mode;
        if (!mode)
            mode = Witness_1.SigHash.TxHash;
        if (typeof tx === 'string')
            tx = __1.Transaction.fromHex(tx);
        var privateKeys = [];
        var outputs = this.getSpendableOutput();
        var _loop_1 = function (input) {
            if (input.input.kind === 'outpoint') {
                var find = outputs.find(function (i) { return i.outpoint.txHash.toString().concat(i.outpoint.index.toString(10)) ===
                    input.input.txHash.toString().concat(input.input.index.toString(10)); });
                if (find) {
                    var _a = find.lock, PK_2 = _a.PK, Coinbase = _a.Coinbase;
                    var hash = '';
                    if (PK_2)
                        hash = PK_2.hash;
                    else if (Coinbase)
                        hash = Coinbase.pkHash;
                    if (hash === '')
                        throw new Error('hash is not spendable');
                    if (hash === this_1.externalPK.hash().bytes.toString('hex')) {
                        privateKeys.push(privates[0]);
                    }
                    else if (hash === this_1.changePK.hash().bytes.toString('hex')) {
                        privateKeys.push(privates[1]);
                    }
                    else {
                        throw new Error("multi wallet not active");
                    }
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, _b = tx.inputs.inputs; _i < _b.length; _i++) {
            var input = _b[_i];
            _loop_1(input);
        }
        return tx.sign(privateKeys, mode).toHex();
    };
    Wallet.prototype.getRequiredAmounts = function (outputs) {
        return lodash_1.reduce(outputs, function (amounts, output) {
            var asset = output.asset, a = output.amount;
            var amount = lodash_1.parseInt(a);
            if (lodash_1.has(amounts, asset)) {
                var amount_1 = lodash_1.get(amounts, asset);
                return lodash_1.set(amounts, asset, lodash_1.parseInt(amount_1) + amount_1);
            }
            else {
                return lodash_1.set(amounts, asset, amount);
            }
        }, {});
    };
    Wallet.prototype.checkContractActivation = function (contractIdOrAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var activeContracts, contractExist;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getActiveContracts()];
                    case 1:
                        activeContracts = _a.sent();
                        if (contractIdOrAddress instanceof __1.ContractId)
                            contractIdOrAddress = contractIdOrAddress.toHex();
                        contractExist = activeContracts.find(function (activeContracts) {
                            return activeContracts.contractId === contractIdOrAddress || activeContracts.address === contractIdOrAddress;
                        });
                        if (lodash_1.isUndefined(contractExist))
                            throw new Error("contract is not active");
                        return [2 /*return*/, contractExist];
                }
            });
        });
    };
    Wallet.prototype.getWalletPK = function (address) {
        var publicKey;
        var path;
        if (address === this.getExternalAddress()) {
            publicKey = this.getExternalPublicKey();
            path = Path.getExternal();
        }
        else {
            publicKey = this.getChangePublicKey();
            path = Path.getChange();
        }
        return { publicKey: publicKey, path: path };
    };
    Wallet.prototype.getPks = function (addresses) {
        if (addresses === void 0) { addresses = this.getAddresses(); }
        var pks = [];
        for (var _i = 0, addresses_1 = addresses; _i < addresses_1.length; _i++) {
            var address = addresses_1[_i];
            pks.push(this.getWalletPK(address));
        }
        return pks;
    };
    Wallet.prototype.refresh = function (addresses) {
        if (addresses === void 0) { addresses = this.getAddresses(this.chain); }
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // TODO: we always ask for all unspent outputs, we might able to make it more efficient by requesting deltas only
                        _a = this;
                        return [4 /*yield*/, this.actions.getUnspentOutputs(addresses)];
                    case 1:
                        // TODO: we always ask for all unspent outputs, we might able to make it more efficient by requesting deltas only
                        _a.unspentOutputs = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Wallet.prototype.sync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var blockChainInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actions.blockChainInfo()];
                    case 1:
                        blockChainInfo = _a.sent();
                        this.syncToBlock = blockChainInfo.blocks;
                        return [2 /*return*/];
                }
            });
        });
    };
    Wallet.prototype.getChangePublicKey = function () {
        return this.changePK;
    };
    Wallet.prototype.getChangePublicKeyHash = function () {
        return this.changePK.hash();
    };
    Wallet.prototype.getOutputs = function (addresses) {
        var _this = this;
        if (addresses === void 0) { addresses = this.getAddresses(); }
        return this.unspentOutputs
            .filter(function (output) {
            switch (Object.keys(output.lock)[0]) {
                case 'Coinbase':
                    return output.lock.Coinbase ? _this.syncToBlock - output.lock.Coinbase.blockNumber > 100 : true;
                default:
                    return true;
            }
        })
            .filter(function (output) {
            var lock = output.lock.Coinbase || output.lock.PK;
            return lock ? addresses.includes(lock.address) : false;
        })
            .map(function (out) { return (__assign(__assign({}, out), { spend: __assign(__assign({}, out.spend), { amount: out.spend.amount.toString() }) })); });
    };
    Wallet.prototype.getSpendableOutput = function (addresses) {
        if (addresses === void 0) { addresses = this.getAddresses(); }
        return this.getOutputs(addresses)
            .sort(function () { return Math.random() - 0.5; });
    };
    Wallet.prototype.getVotingSignatures = function (message, privates) {
        var _this = this;
        var sigs = [];
        var pks = this.getPks();
        if (lodash_1.isEmpty(pks))
            throw new Error("the keys are not funded");
        pks.forEach(function (item) {
            var publicKey = item.publicKey, path = item.path;
            var signature = _this.signMessage(message, path, privates);
            sigs.push([publicKey.toString(), new __1.DataSignature(signature)]);
        });
        return sigs;
    };
    Wallet.prototype.collectInputs = function (requiredAmounts, privates, addresses) {
        var _this = this;
        if (addresses === void 0) { addresses = this.getAddresses(); }
        var inputs = [];
        var change = {};
        var kind = "";
        lodash_1.forIn(requiredAmounts, function (amount, asset) {
            var collectedAmount = 0;
            for (var _i = 0, _a = _this.getSpendableOutput(addresses); _i < _a.length; _i++) {
                var output = _a[_i];
                var _b = output.lock, PK_3 = _b.PK, Coinbase = _b.Coinbase;
                var hash = '';
                var spendableLock = PK_3 || Coinbase;
                if (spendableLock && output.spend.asset === asset) {
                    collectedAmount += lodash_1.parseInt(output.spend.amount);
                    var privateKey = void 0;
                    if (PK_3)
                        hash = PK_3.hash;
                    else if (Coinbase)
                        hash = Coinbase.pkHash;
                    if (hash === '')
                        throw new Error('hash is not spendable');
                    var pointedOutput = void 0;
                    if (PK_3) {
                        pointedOutput = {
                            outpoint: output.outpoint,
                            lock: {
                                PK: {
                                    hash: hash,
                                    address: spendableLock.address
                                }
                            },
                            spend: output.spend
                        };
                    }
                    else if (Coinbase) {
                        pointedOutput = {
                            outpoint: output.outpoint,
                            lock: {
                                Coinbase: {
                                    pkHash: hash,
                                    address: spendableLock.address,
                                    blockNumber: Coinbase.blockNumber
                                }
                            },
                            spend: output.spend
                        };
                    }
                    else {
                        throw new Error("Output not spendable");
                    }
                    if (!lodash_1.isUndefined(privates)) {
                        kind = "withPrv";
                        if (hash === _this.externalPK.hash().bytes.toString('hex')) {
                            privateKey = privates[0];
                        }
                        else if (hash === _this.changePK.hash().bytes.toString('hex')) {
                            privateKey = privates[1];
                        }
                        else
                            throw new Error('Hash Mismatch');
                        inputs.push([privateKey, pointedOutput]);
                    }
                    else {
                        kind = "without";
                        inputs.push(pointedOutput);
                    }
                    if (collectedAmount === lodash_1.parseInt(amount)) {
                        break;
                    }
                    else if (collectedAmount > lodash_1.parseInt(amount)) {
                        lodash_1.set(change, asset, collectedAmount - lodash_1.parseInt(amount));
                        break;
                    }
                }
            }
            if (collectedAmount < lodash_1.parseInt(amount)) {
                throw new Error('not enough tokens');
            }
        });
        switch (kind) {
            case "without":
                return { inputs: { kind: kind, data: inputs }, change: change };
            case "withPrv":
                return { inputs: { kind: kind, data: inputs }, change: change };
            default:
                throw new Error("missing kind, contact developer");
        }
    };
    Wallet.prototype.updateContractData = function (contractData) {
        if (contractData.provideReturnAddress) {
            var returnAddressDict = new __1.Dictionary([[
                    "returnAddress",
                    new __1.DataLock(new __1.PK(this.externalPK.hash()))
                ]]);
            if (contractData.messageBody instanceof __1.Dictionary && !lodash_1.isEmpty(contractData.messageBody.data)) {
                contractData.messageBody = new __1.Dictionary(__spreadArrays(contractData.messageBody.data, returnAddressDict.data));
            }
            else {
                contractData.messageBody = returnAddressDict;
            }
        }
        return contractData;
    };
    Wallet.prototype.addTxBuilderInputs = function (inputs) {
        var txBuilder = new __1.TransactionBuilder(this.chain);
        if (inputs.kind === "withPrv") {
            inputs.data.forEach(function (_a) {
                var privateKey = _a[0], input = _a[1];
                return txBuilder.addInput(input.outpoint.txHash, input.outpoint.index, privateKey);
            });
        }
        else {
            inputs.data.forEach(function (input) { return txBuilder.addInput(input.outpoint.txHash, input.outpoint.index); });
        }
        return txBuilder;
    };
    return Wallet;
}());
exports.Wallet = Wallet;
//# sourceMappingURL=Wallet.js.map